import "./custom-work-flow.css";

export function CustomWorkFlow() {
  return (
    <section className="custom-work-flow">
      <div className="custom-work-flow__content">
        <h1 className="custom-work-flow__title">
          Trust & Safety Tools, powered by AI
        </h1>
        <p className="custom-work-flow__subtitle">
          Get to know the renter before handing over the keys.
        </p>
      </div>
    </section>
  );
}
